module.exports = __webpack_public_path__ + "img/numero.06a8bb3a.svg";